<template>
  <div class="flex flex-row bg-grey-50 rounded-md p-16 items-center">
    <InfoCircle class="w-24 flex-shrink-0" />
    <p :class="['font-sans-light ml-8', textClass]">
      {{ text }}
    </p>
  </div>
</template>

<script>
import { InfoCircle } from '~/assets/svgs/index'

export default {
  components: {
    InfoCircle,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    textClass: {
      type: String,
      default: '',
    },
  },
}
</script>
